/* fdb-track.js: one event layer for the whole Factory Direct Blinds store.
 *
 *   window.fdbTrack(name, key, val, extra)   or   document.dispatchEvent(new CustomEvent('fdb:track', {detail:{event, key, val}}))
 *
 * Every event goes to four places at once (each best-effort, nothing here can break the page):
 *   GA4      gtag('event', name, {send_to: 'G-11TY7FC260'})   the theme's gtag also carries the Google Ads tag (AW-385601161); send_to keeps
 *            these events on the GA4 property only. GA4 drops everything past 500 events per session, so the noisy names (GA_NOISY) stop
 *            going to GA4 after 300 events in a session; cart, checkout, callback, builder and form events always go.
 *   GTM      dataLayer.push({event: name, fdb: {...}})   for custom-event triggers in the GTM container
 *   Clarity  clarity('event', name)                      if Clarity is ever installed
 *   IG       igEvents.push({event: name})                 Intelligems metrics (whitelist, no section / scroll / click noise)
 *   Worker   sendBeacon to the fdb-events worker          our own D1 store: sessions, funnels, US-only reports
 *
 * Automatic events (no per-section code):
 *   section_reach  key = section id suffix, val = position   once per section, the moment any of it enters the viewport ("scrolled to")
 *   section_view   key = section id suffix, val = position   once per section after 1 s "in view" (half visible, or covering 60% of the viewport)
 *   ui_click       key = "<section>|<label>"                 every a / button / label / summary tap; cart| and menu| for the drawers
 *   scroll_depth   val = 25 / 50 / 75 / 100;   time_on_page   val = 15 / 45 / 90 / 180 seconds of visible time
 *   video_play / video_progress (25/50/75/95) / video_complete / video_unmute   native <video> and YouTube iframes; key = "<section>|<file>"
 *   gallery_slide  key = slide number, val = total (Builder 2.0 gallery thumbs); gallery_mid (6th), gallery_complete (last), gallery_dwell
 *   tooltip_open   key = pricing | measuresafe | data-fdb-tip        upsell_add / upsell_remove   key = measuresafe (the MeasureSafe tick)
 *   builder_start  the first step the shopper opened; builder_step_open / builder_step_done  key = step title (colour, mount_size, control...)
 *   builder_color  key = colour name;  builder_mount  key = Inside / Outside;  builder_size  key = width | height, val = inches
 *   atc_click      the Add to cart press (Builder 2.0, classic product form);  add_to_cart  a confirmed /cart/add call (fetch, XHR or form)
 *   sample_add     a free-sample button in the builder (key = colour);  cart_updated  the theme's cart:updated event (key = source)
 *   cart_open (drawer or /cart page), checkout_click (val = order total shown, extra.cart = what the cart held), menu_open, drawer_open
 *   cart_remove    key = what left the cart (bundle name, "MeasureSafe: <shade>", sample or product title), val = dollars removed,
 *                  extra {kind: shade|measuresafe|sample|item, size, qty, left, via: ajax|page}. Read from /cart.js snapshots, not clicks,
 *                  so every path counts: bundle delete, remove links, quantity boxes, the drawer, another tab.
 *   cart_qty       a quantity raised in the cart (key, val = dollars added, extra.qty / now)
 *   callback_open  the help pop-up / request-a-callback triggers;  callback_submit  the pop-up's contact form submitted;
 *   callback_confirmed  the success banner after Shopify's reload;  form_submit  every contact / newsletter form (extra.kind)
 *   Purchase attribution: when the cart is opened, something is added or Checkout is pressed, the cart gets the hidden attributes
 *   _fdb_sid / _fdb_vid (underscore = never shown to the shopper). They arrive on the Shopify order; the events worker polls orders
 *   and marks the session as purchased. Nothing else about the cart is touched.
 *
 * Config comes from snippets/fdb-track.liquid (window.__fdbTrackCfg): endpoint, page template, product handle, price shown, ga4.
 * ?fdb-track-debug=1 logs every event to the console. Built from the FDB tracker by documentation/tools/build_fdb_track.py.
 */
(function () {
  'use strict';
  if (window.fdbTrack) return;
  var CFG = window.__fdbTrackCfg || {};
  if (CFG.enabled === false) { window.fdbTrack = function () {}; return; }
  var W = window, D = document;
  var GA_NOISY = { ui_click: 1, section_view: 1, section_reach: 1, scroll_depth: 1, time_on_page: 1, video_progress: 1, gallery_slide: 1, gallery_dwell: 1, gallery_zoom_slide: 1 };
  var IG_ALLOW = { tooltip_open: 1, upsell_add: 1, upsell_remove: 1, video_play: 1, cart_open: 1, checkout_click: 1, form_submit: 1, callback_open: 1, callback_submit: 1,
    drawer_open: 1, add_to_cart: 1, cart_remove: 1, atc_click: 1, sample_add: 1, builder_start: 1, builder_step_done: 1, builder_color: 1, builder_size: 1, product_card_click: 1, hero_cta_click: 1 };

  // ---- ids: visitor (1 y), session (30 min idle), pageview ----
  function rnd() { var s = ''; while (s.length < 16) s += Math.floor(Math.random() * 16).toString(16); return s; }
  function store(kind, key, val) {
    try { var s = kind === 'l' ? localStorage : sessionStorage; if (val === undefined) return s.getItem(key); s.setItem(key, val); } catch (e) { return null; }
  }
  var vid = store('l', 'fdb_vid'); if (!vid) { vid = rnd(); store('l', 'fdb_vid', vid); }
  var now = Date.now();
  var sid = store('l', 'fdb_sid'), sidAt = parseInt(store('l', 'fdb_sid_at') || '0', 10);
  if (!sid || now - sidAt > 30 * 60 * 1000) { sid = rnd(); store('l', 'fdb_sid', sid); }
  store('l', 'fdb_sid_at', String(now));
  var pv = rnd();
  var t0 = now;
  var mobile = W.innerWidth < 750;
  // traffic source: utm_* on this landing, remembered for the session (utm_source falls back to gclid / fbclid / ttclid)
  var q = {}; try { location.search.replace(/^\?/, '').split('&').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) q[decodeURIComponent(kv.slice(0, i))] = decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' ')); }); } catch (e) {}
  var utm = null;
  if (q.utm_source || q.gclid || q.fbclid || q.ttclid) utm = { s: (q.utm_source || (q.gclid ? 'google' : q.fbclid ? 'facebook' : 'tiktok')).slice(0, 40), m: (q.utm_medium || (q.gclid || q.fbclid || q.ttclid ? 'cpc' : '')).slice(0, 40), c: (q.utm_campaign || '').slice(0, 80) };
  if (utm) store('l', 'fdb_utm', JSON.stringify(utm)); else { try { utm = JSON.parse(store('l', 'fdb_utm') || 'null'); } catch (e) { utm = null; } }
  if (utm && sidAt && now - sidAt > 30 * 60 * 1000 && !q.utm_source) utm = null;   // stale source from an older session
  var pageN = (parseInt(store('s', 'fdb_pn') || '0', 10) || 0) + 1; store('s', 'fdb_pn', String(pageN));
  var page = {
    path: location.pathname, tpl: CFG.tpl || '', prod: CFG.prod || '', price: CFG.price || 0,
    dev: mobile ? 'm' : 'd', ref: (function () { try { return D.referrer ? new URL(D.referrer).hostname : ''; } catch (e) { return ''; } })(),
    w: W.innerWidth, h: W.innerHeight, utm: utm, pn: pageN
  };
  // first touch: the source that brought this browser here the first time, kept 30 days and sent with every pageview (ft),
  // so a visitor who comes back from an open tab or a bookmark is not reported as "inside the site" / direct
  var ft = null; try { ft = JSON.parse(store('l', 'fdb_ft') || 'null'); } catch (e) { ft = null; }
  if (!ft || !ft.t || now - ft.t > 30 * 24 * 3600 * 1000) {
    ft = utm ? { s: utm.s, m: utm.m || '', c: utm.c || '', t: now } : { s: (page.ref && page.ref.indexOf('factorydirectblinds') < 0 && page.ref.indexOf('myshopify') < 0) ? page.ref : 'direct', m: '', c: '', t: now };
    store('l', 'fdb_ft', JSON.stringify(ft));
  }
  page.ft = { s: ft.s, m: ft.m, c: ft.c };

  // ---- fan-out ----
  var buffer = [];       // [dt, name, key, val, extra]
  var sent = 0;          // events already delivered to the worker
  var seenTip = {};      // tooltip keys opened in this pageview
  var intent = '', lastForm = '';   // last callback / survey button pressed; last form id reported (de-duplication)
  function toParams(name, key, val, extra) {
    var p = { fdb_key: key == null ? '' : String(key).slice(0, 100), fdb_val: typeof val === 'number' ? val : 0, fdb_tpl: page.tpl, fdb_prod: page.prod, fdb_dev: page.dev };
    if (extra) for (var k in extra) if (extra.hasOwnProperty(k) && p['fdb_' + k] === undefined) { var v = extra[k]; p['fdb_' + k] = typeof v === 'number' ? v : String(v).slice(0, 100); }
    return p;
  }
  function track(name, key, val, extra) {
    try {
      if (!name) return;
      name = String(name).replace(/[^a-z0-9_]/gi, '_').slice(0, 40);
      var rec = [Date.now() - t0, name, key == null ? '' : String(key).slice(0, 120), typeof val === 'number' ? val : 0, extra || null];
      buffer.push(rec);
      if (buffer.length - sent >= 40) send(false);
      var p = toParams(name, key, val, extra);
      try {
        var gaN = parseInt(store('s', 'fdb_ga_n') || '0', 10) || 0;
        // send_to pins the event to the GA4 property only: the same gtag also carries the Google Ads tag (AW-), which must not see these
        if (typeof W.gtag === 'function' && !(GA_NOISY[name] && gaN >= 300) && gaN < 480) { p.send_to = CFG.ga4 || 'G-11TY7FC260'; W.gtag('event', name, p); store('s', 'fdb_ga_n', String(gaN + 1)); }
      } catch (e) {}
      try { W.dataLayer = W.dataLayer || []; W.dataLayer.push({ event: name, fdb: p }); } catch (e) {}
      try { if (typeof W.clarity === 'function') W.clarity('event', name); } catch (e) {}
      try { if (IG_ALLOW[name]) { W.igEvents = W.igEvents || []; W.igEvents.push({ event: name }); } } catch (e) {}
      if (CFG.debug) console.info('[fdb track]', name, key, val, extra || '');
    } catch (e) {}
  }
  W.fdbTrack = track;
  D.addEventListener('fdb:track', function (e) { var d = e.detail || {}; track(d.event || d.name, d.key, d.val, d.extra); });

  // ---- worker delivery: one row per pageview, replaced on every send (2-3 writes per pageview) ----
  var sendTimer = null;
  function send(final) {
    if (!CFG.endpoint || !buffer.length) return;
    var body = JSON.stringify({ v: 1, pv: pv, vid: vid, sid: sid, t0: t0, dur: Date.now() - t0, page: page, ev: buffer, done: !!final });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(CFG.endpoint, body)) { sent = buffer.length; return; }
    } catch (e) {}
    try { fetch(CFG.endpoint, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }); sent = buffer.length; } catch (e) {}
  }
  function schedule(ms) { clearTimeout(sendTimer); sendTimer = setTimeout(function () { send(false); }, ms); }
  D.addEventListener('visibilitychange', function () { if (D.visibilityState === 'hidden') send(true); });
  W.addEventListener('pagehide', function () { send(true); });
  schedule(8000);                 // an early copy in case the tab dies before pagehide
  setInterval(function () { if (buffer.length > sent) send(false); }, 20000);
  W.addEventListener('beforeunload', function () { send(true); });

  // ---- purchase attribution: session id on the cart ----
  function tagCart(keepalive) {
    try {
      if (store('s', 'fdb_cart_tag') === sid) return;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { _fdb_sid: sid, _fdb_vid: vid } }), keepalive: !!keepalive, credentials: 'same-origin' })
        .then(function (r) { if (r.ok) store('s', 'fdb_cart_tag', sid); }).catch(function () {});
    } catch (e) {}
  }
  D.addEventListener('pointerdown', function (e) { var el = e.target && e.target.closest ? e.target.closest('[data-fdb-checkout], [name="checkout"], a[href*="/checkout"]') : null; if (el) tagCart(true); }, true);

  // ---- helpers ----
  function sectionOf(el) {
    // the side cart and the mobile menu live inside the header section: report them as their own places
    var ov = el && el.closest ? el.closest('#CartDrawer, #MobileNav, .mobile-nav-wrapper') : null;
    if (ov) return ov.id === 'CartDrawer' ? 'cart' : 'menu';
    var s = el && el.closest ? el.closest('.shopify-section, [data-section-id]') : null;
    if (!s) return '';
    var id = s.id || s.getAttribute('data-section-id') || '';
    var i = id.lastIndexOf('__');
    var key = (i > -1 ? id.slice(i + 2) : id.replace(/^shopify-section-/, '')).slice(0, 60);
    return key === 'MainContent' ? '' : key;
  }
  function labelOf(el) {
    var t = el.getAttribute('aria-label') || el.getAttribute('data-track-label') || (el.innerText || el.textContent || '');
    t = String(t).replace(/\s+/g, ' ').trim();
    if (!t && el.value && /^(submit|button)$/i.test(el.type || '')) t = String(el.value).trim();
    if (!t) { var img = el.querySelector && el.querySelector('img[alt]'); if (img) t = img.alt; }
    if (!t && el.href) t = el.href.replace(/[?#].*/, '').split('/').pop();
    return t.slice(0, 40);
  }
  function priceShown() { var el = D.querySelector('[data-price-bar], .builder-v2__price-bar, .product-single__price, [data-cart-order-total]'); var m = el ? /\$\s*([\d,]+(?:\.\d+)?)/.exec(el.innerText || el.textContent || '') : null; return m ? Math.round(parseFloat(m[1].replace(/,/g, ''))) : (page.price || 0); }
  function fileOf(src) { return String(src || '').replace(/[?#].*/, '').split('/').pop().slice(0, 40); }

  // ---- section views ----
  function sectionViews() {
    // every section wrapper, sized when it is checked and not here: while the page is still rendering the theme collapses off-screen
    // sections to zero height (content-visibility: auto), so a height filter at boot dropped everything below the first section
    var secs = Array.prototype.slice.call(D.querySelectorAll('.shopify-section'));
    var timers = {}, done = {}, reached = {};   // reached = its top entered the viewport at all (no dwell): "scrolled to", next to "looked at"
    function rectOf(el) { var r = el.getBoundingClientRect(); if (r.height > 40) return r; for (var c = el.firstElementChild; c; c = c.nextElementSibling) { var cr = c.getBoundingClientRect(); if (cr.height > 40) return cr; } return r; }
    function inView(el) {
      var r = rectOf(el), vh = W.innerHeight || 1, vw = W.innerWidth || 1;
      var visH = Math.min(r.bottom, vh) - Math.max(r.top, 0), visW = Math.min(r.right, vw) - Math.max(r.left, 0);
      if (visH <= 0 || visW <= 0 || r.height <= 40) return false;
      return visH / r.height >= 0.5 || visH >= vh * 0.6;
    }
    function check() {
      secs.forEach(function (el) {
        var key = sectionOf(el); if (!key) return;
        if (!reached[key]) { var rr = rectOf(el); if (rr.height > 40 && rr.top < (W.innerHeight || 1) && rr.bottom > 0) { reached[key] = 1; track('section_reach', key, secs.indexOf(el) + 1); } }
        if (done[key]) return;
        var vis = inView(el);
        if (vis && !timers[key]) {
          timers[key] = setTimeout(function () {
            if (!inView(el)) { timers[key] = null; return; }
            done[key] = 1;
            var h = el.querySelector('h1, h2, .h1, .h2');
            track('section_view', key, secs.indexOf(el) + 1, { label: h ? (h.innerText || '').replace(/\s+/g, ' ').trim().slice(0, 60) : '' });
          }, 1000);
        } else if (!vis && timers[key]) { clearTimeout(timers[key]); timers[key] = null; }
      });
    }
    var t = null; function onScroll() { clearTimeout(t); t = setTimeout(check, 120); }
    W.addEventListener('scroll', onScroll, { passive: true }); W.addEventListener('resize', onScroll, { passive: true });
    if ('IntersectionObserver' in W) {   // fine-grained visibility changes (2% steps) so tall sections and jumps are caught without waiting for a scroll event
      var steps = []; for (var i = 0; i <= 50; i++) steps.push(i / 50);
      var io = new IntersectionObserver(function () { check(); }, { threshold: steps });
      secs.forEach(function (s) { io.observe(s); });
    }
    check(); setTimeout(check, 1500);
  }

  // ---- clicks ----
  D.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a, button, [role="button"], label, summary, input[type="submit"]') : null;
    if (!el) return;
    if (el.closest('.builder-v2__thumb, .builder-v2__gallery-dot, .builder-v2__gallery-arrow')) return; // gallery_slide covers the gallery controls
    var label = labelOf(el); if (!label) return;
    var sec = sectionOf(el);
    var extra = {};
    // several buttons with the same words in one section ("CHOOSE" x3): say which one. "CHOOSE · Nordwood Classic (2 of 3)"
    try {
      var host = el.closest('.shopify-section, [data-section-id]');
      if (host && label.length < 30) {
        var same = Array.prototype.filter.call(host.querySelectorAll('a, button, [role="button"]'), function (x) { return x.offsetParent !== null && labelOf(x) === label; });
        if (same.length > 1 && same.length <= 12) {
          var ctx = '', card = el.parentElement;
          for (var up = 0; up < 5 && card && card !== host && !ctx; up++, card = card.parentElement) {
            var hd = card.querySelector('h2, h3, h4, [class*="title"], [class*="name"], [class*="heading"]');
            if (hd && !hd.contains(el)) { var tx = (hd.innerText || hd.textContent || '').replace(/\s+/g, ' ').trim(); if (tx && tx !== label && tx.length < 60) ctx = tx; }
          }
          if (!ctx && el.href) ctx = String(el.href).replace(/[?#].*/, '').replace(/\/$/, '').split('/').pop().replace(/-/g, ' ');
          var pos = same.indexOf(el) + 1;
          extra.pos = pos; extra.of = same.length;
          label = (label + (ctx ? ' · ' + ctx.slice(0, 34) : '') + ' (' + pos + ' of ' + same.length + ')').slice(0, 90);
        }
      }
    } catch (err) {}
    if (el.href) extra.href = String(el.href).replace(/^https?:\/\/[^/]+/, '').slice(0, 100);
    track('ui_click', sec + '|' + label, 0, extra);
    if (el.hasAttribute('data-fdb-checkout') || el.getAttribute('name') === 'checkout' || /\/checkout/.test(el.getAttribute('href') || '')) {
      var tot = D.querySelector('[data-cart-order-total], [data-cart-subtotal]');
      if (Date.now() - (W.__fdbCo || 0) > 1500) { W.__fdbCo = Date.now(); store('l', 'fdb_cart_co', String(Date.now())); track('checkout_click', page.prod, tot ? parseInt(String(tot.textContent).replace(/[^0-9]/g, ''), 10) || 0 : 0, { section: sec, cart: cartBrief() }); }   // the cart re-dispatches the click after validation
      tagCart(true);
    }
    // cart_remove / cart_qty come from cart snapshots (cartSync), not from clicks: the cart page's remove handler calls
    // stopImmediatePropagation in the capture phase, so remove clicks never reach this listener
    if (el.closest('[data-help-open], [data-callback-open]') || /callback|call back|call me|request a call|talk to an expert/i.test(label)) { intent = 'callback'; track('callback_open', sec + '|' + label); }
    // Builder 2.0 and the classic product form: the Add to cart press. Confirmed adds come from the /cart/add hook as add_to_cart.
    if (el.closest('[data-atc-btn], .builder-v2__atc-btn, .product-form__cart-submit, [name="add"], #AddToCart')) { track('atc_click', page.prod, priceShown(), { label: label }); tagCart(true); }
    if (el.closest('.builder-v2__sample-btn')) track('sample_add', el.getAttribute('data-color') || label, 0, { section: sec });
    if (el.closest('.builder-v2__mount-option')) track('builder_mount', label);
    var colorBtn = el.closest('[data-color]'); if (colorBtn && el.closest('[data-builder-steps]')) track('builder_color', colorBtn.getAttribute('data-color'));
  }, true);

  // ---- scroll depth + time on page ----
  (function () {
    var marks = [25, 50, 75, 100], hit = {};
    function onScroll() {
      var h = Math.max(D.documentElement.scrollHeight, D.body.scrollHeight) - W.innerHeight; if (h <= 0) return;
      var pct = Math.round((W.pageYOffset / h) * 100);
      marks.forEach(function (m) { if (pct >= m && !hit[m]) { hit[m] = 1; track('scroll_depth', page.tpl, m); } });
    }
    W.addEventListener('scroll', onScroll, { passive: true }); setTimeout(onScroll, 1500);
    var vis = 0, last = Date.now(), tm = [15, 45, 90, 180], ti = 0;
    setInterval(function () {
      var n = Date.now(); if (D.visibilityState !== 'hidden') vis += n - last; last = n;
      if (ti < tm.length && vis >= tm[ti] * 1000) { track('time_on_page', page.tpl, tm[ti]); ti++; }
    }, 1000);
  })();

  // ---- videos: native + wistia ----
  (function () {
    var seen = {}, prog = {}, wk = false, wasMuted = {}, unmuted = {};
    // sound turned on in a video that started muted (sale / video page hero): the deliberate "I am watching this" moment
    ['volumechange', 'mute-change', 'volume-change'].forEach(function (ev) { D.addEventListener(ev, function (e) {
      var el = e.target; if (!isPlayer(el) || el.muted) return;
      var k = keyOf(el); if (!wasMuted[k] || unmuted[k]) return; unmuted[k] = 1;
      track('video_unmute', k, Math.round(el.currentTime || 0));
    }, true); });
    function isPlayer(el) { return el && (el.tagName === 'VIDEO' || el.tagName === 'WISTIA-PLAYER'); }
    function wistiaKey(el) {
      if (wk !== false) return; wk = null;
      try { var k = typeof el.visitorKey === 'function' ? el.visitorKey() : el.visitorKey; if (k) { wk = String(k); track('wistia_visitor', wk); } } catch (e) {}
    }
    // key = where|file. where: "tour" = the pop-up player (Watch product tour / founders video), "gallery" = the inline gallery
    // video slide (autoplays muted), else the section id. extra.auto = 1 when the play happened without any user gesture.
    function keyOf(el) {
      var f = el.tagName === 'WISTIA-PLAYER' ? (el.getAttribute('media-id') || 'wistia') : fileOf(el.currentSrc || el.src || (el.querySelector('source') || {}).src);
      var where = el.closest('.builder-v2__gallery-main, .builder-v2__gallery-wrap, .product-single__photos') ? 'gallery' : sectionOf(el);
      return where + '|' + f;
    }
    D.addEventListener('play', function (e) {
      var el = e.target; if (!isPlayer(el)) return;
      var k = keyOf(el); if (seen[k]) return; seen[k] = 1;
      // the gallery slide autoplays whenever the shopper reaches it, so it is never a deliberate play (gallery_video_view covers it)
      var auto = k.indexOf('gallery|') === 0 ? 1 : navigator.userActivation ? (navigator.userActivation.hasBeenActive ? 0 : 1) : (el.autoplay ? 1 : 0);
      // background clips (muted loops and muted autoplay that start when scrolled into view) are never a deliberate play, whatever happened before
      if (el.tagName === 'VIDEO' && el.muted && (el.loop || el.autoplay || !el.controls)) auto = 1;
      if (el.muted) wasMuted[k] = 1;
      track('video_play', k, 0, { muted: el.muted ? 1 : 0, auto: auto });
      if (el.tagName === 'WISTIA-PLAYER') setTimeout(function () { wistiaKey(el); }, 1500);
    }, true);
    function marks(k, pct) {
      var best = prog[k] || 0;
      [25, 50, 75, 95].forEach(function (m) { if (pct >= m && best < m) { best = m; track('video_progress', k, m); } });
      prog[k] = best;
    }
    function progress(e) {
      var el = e.target; if (!isPlayer(el)) return;
      var d = el.duration || 0, c = el.currentTime || 0; if (!(d > 0) || !(c > 0)) return;
      marks(keyOf(el), (c / d) * 100);
    }
    ['timeupdate', 'time-update', 'second-change'].forEach(function (ev) { D.addEventListener(ev, progress, true); });
    // videos already running when this script starts (autoplay hero loops): log them as automatic plays so progress has a play to belong to
    function catchUp() { Array.prototype.forEach.call(D.querySelectorAll('video'), function (v) { if (!v.paused && !v.ended) { var k = keyOf(v); if (!seen[k]) { seen[k] = 1; track('video_play', k, 0, { muted: v.muted ? 1 : 0, auto: 1 }); } } }); }
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', catchUp); else catchUp();
    setTimeout(catchUp, 3000);
    D.addEventListener('percent-watched-change', function (e) {   // Wistia: share of the video actually seen
      var el = e.target; if (!isPlayer(el)) return;
      var p = e.detail && (e.detail.percentWatched != null ? e.detail.percentWatched : e.detail.percent); if (p == null) p = el.percentWatched;
      if (typeof p === 'number') marks(keyOf(el), p <= 1 ? p * 100 : p);
    }, true);
    ['ended', 'end'].forEach(function (ev) { D.addEventListener(ev, function (e) {
      var el = e.target; if (!isPlayer(el)) return;
      var k = keyOf(el); if (prog[k] === 100) return; marks(k, 95); prog[k] = 100; track('video_complete', k, 100);
    }, true); });
  })();

  // ---- YouTube iframes: state + progress via the embed's postMessage channel ----
  (function () {
    var players = [], n = 0;
    function attach(ifr) {
      if (ifr.__fdb || !/youtube(-nocookie)?\.com\/embed\//.test(ifr.src || '')) return;
      ifr.__fdb = 1;
      var id = (ifr.src.match(/\/embed\/([^?&/]+)/) || [])[1] || 'yt';
      var rec = { el: ifr, key: sectionOf(ifr) + '|yt:' + id, title: (ifr.title || '').slice(0, 60), played: 0, best: 0, done: 0, n: ++n };
      players.push(rec);
      if (ifr.src.indexOf('enablejsapi=1') < 0) ifr.src = ifr.src + (ifr.src.indexOf('?') > -1 ? '&' : '?') + 'enablejsapi=1&origin=' + encodeURIComponent(location.origin);
      var listen = function () { try { ifr.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: rec.n, channel: 'widget' }), '*'); } catch (e) {} };
      ifr.addEventListener('load', listen); setTimeout(listen, 1500);
    }
    function scan(root) { Array.prototype.forEach.call((root || D).querySelectorAll ? (root || D).querySelectorAll('iframe') : [], attach); }
    if ('MutationObserver' in W) new MutationObserver(function (muts) {
      muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (nd) { if (nd.nodeType !== 1) return; if (nd.tagName === 'IFRAME') attach(nd); else scan(nd); }); });
    }).observe(D.documentElement, { childList: true, subtree: true });
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
    W.addEventListener('message', function (e) {
      if (!/youtube(-nocookie)?\.com$/.test(e.origin || '')) return;
      var d = e.data; if (typeof d === 'string') { try { d = JSON.parse(d); } catch (x) { return; } }
      if (!d || !d.event) return;
      var rec = null; for (var i = 0; i < players.length; i++) if (players[i].el.contentWindow === e.source) { rec = players[i]; break; }
      if (!rec) return;
      var st = d.event === 'onStateChange' ? d.info : (d.event === 'infoDelivery' && d.info && d.info.playerState != null ? d.info.playerState : null);
      if (st === 1 && !rec.played) { rec.played = 1; track('video_play', rec.key, 0, { muted: 0, auto: 0, title: rec.title }); }
      if (d.event === 'infoDelivery' && d.info && d.info.duration > 0 && d.info.currentTime > 0) {
        var pct = d.info.currentTime / d.info.duration * 100;
        [25, 50, 75, 95].forEach(function (m) { if (pct >= m && rec.best < m) { rec.best = m; track('video_progress', rec.key, m); } });
      }
      if (st === 0 && !rec.done) { rec.done = 1; if (rec.best < 95) { rec.best = 95; track('video_progress', rec.key, 95); } track('video_complete', rec.key, 100); }
    });
  })();

  // ---- tooltips (pricing disclaimer, MeasureSafe) + the MeasureSafe tick (reported as the upsell) ----
  (function () {
    var last = {};
    function tip(el) {
      var k = (el.hasAttribute('data-pricing-tooltip-trigger') || el.classList.contains('pricing-tooltip__trigger')) ? 'pricing' : el.hasAttribute('data-bv2-measuresafe-tooltip-trigger') ? 'measuresafe' : (el.getAttribute('data-fdb-tip') || labelOf(el));
      var n = Date.now(); if (last[k] && n - last[k] < 5000) return; last[k] = n; seenTip[k] = n;
      track('tooltip_open', k, 0, { section: sectionOf(el) });
    }
    D.addEventListener('mouseover', function (e) {
      if (mobile) return;
      var el = e.target && e.target.closest ? e.target.closest('[data-pricing-tooltip-trigger], [data-bv2-measuresafe-tooltip-trigger], [data-fdb-tip], .pricing-tooltip__trigger') : null; if (el) tip(el);
    });
    D.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-pricing-tooltip-trigger], [data-bv2-measuresafe-tooltip-trigger], [data-fdb-tip], .pricing-tooltip__trigger') : null; if (el) tip(el);
    }, true);
    D.addEventListener('change', function (e) {
      var el = e.target; if (!el || !el.matches || !el.matches('input.bv2-measuresafe-checkbox, input[data-bv2-measuresafe], input[data-fdb-add]')) return;
      var k = el.getAttribute('data-fdb-add') || 'measuresafe';
      var after = seenTip[k] ? 1 : 0, anyTip = 0; for (var t in seenTip) if (seenTip.hasOwnProperty(t)) anyTip = 1;
      track(el.checked ? 'upsell_add' : 'upsell_remove', k, 0, { after_tip: after, any_tip: anyTip, tip_s: after ? Math.round((Date.now() - seenTip[k]) / 1000) : 0 });
    }, true);
  })();

  // ---- gallery: watch the active thumb ----
  function gallery() {
    var wraps = D.querySelectorAll('.builder-v2__gallery-thumbs, .product-single__thumbnails');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var thumbs = wrap.querySelectorAll('.builder-v2__thumb, .product-single__thumbnail'), total = thumbs.length; if (total < 2 || !('MutationObserver' in W)) return;
      var cur = 0, maxIdx = 0, sec = sectionOf(wrap), fired = {}, since = Date.now();
      // time spent on each photo: sent when the photo changes and when the page is left (visible time only, 1 s to 10 min)
      function dwell() {
        var s = Math.round((Date.now() - since) / 1000); since = Date.now();
        if (D.visibilityState === 'hidden') return;
        if (s >= 1) track('gallery_dwell', cur + 1, Math.min(s, 600), { section: sec });
      }
      D.addEventListener('visibilitychange', function () { if (D.visibilityState === 'hidden') dwell(); else since = Date.now(); });
      W.addEventListener('pagehide', dwell);
      new MutationObserver(function () {
        var i = -1; for (var n = 0; n < total; n++) if (thumbs[n].classList.contains('builder-v2__thumb--active') || thumbs[n].classList.contains('active')) { i = n; break; }
        if (i < 0 || i === cur) return;
        dwell();
        cur = i; var kind = thumbs[i].querySelector('video, .builder-v2__thumb-play, [data-video]') ? 'video' : 'image';
        track('gallery_slide', i + 1, total, { kind: kind, section: sec });
        if (i > maxIdx) maxIdx = i;
        if (kind === 'video' && !fired.v) { fired.v = 1; track('gallery_video_view', i + 1, total); }
        if (i + 1 === 6 && !fired.m) { fired.m = 1; track('gallery_mid', 6, total); }
        if (i + 1 === total && !fired.c) { fired.c = 1; track('gallery_complete', total, total); }
      }).observe(wrap, { attributes: true, subtree: true, attributeFilter: ['class'] });
    });
    // full-screen photo viewer (tap on the main photo): opened on which photo, and every photo looked at inside it
    Array.prototype.forEach.call(D.querySelectorAll('[data-fdb-lightbox]'), function (lb) {
      var count = lb.querySelector('[data-fdb-lightbox-count]'), sec = sectionOf(lb), last = '';
      function at() { var m = /(\d+)\s*\/\s*(\d+)/.exec(count ? count.textContent : ''); return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : [0, 0]; }
      new MutationObserver(function () {
        if (lb.hidden) { last = ''; return; }
        var p = at(); if (!p[0]) return;
        var k = p[0] + '/' + p[1]; if (k === last) return;
        track(last ? 'gallery_zoom_slide' : 'gallery_zoom', p[0], p[1], { section: sec }); last = k;
      }).observe(lb, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true, characterData: true });
    });
  }

  // ---- cart drawer, drawers, forms ----
  D.addEventListener('toggle', function (e) {
    var el = e.target; if (!el || !el.matches) return;
    if (el.tagName === 'DETAILS' && el.open) { var s = el.querySelector('summary'); if (s) track('drawer_open', sectionOf(el) + '|' + labelOf(s)); }
  }, true);
  function drawers() {
    if (!('MutationObserver' in W)) return;
    var cartOpen = 0;
    function cartNow() { if (cartOpen) return; cartOpen = 1; setTimeout(function () { cartOpen = 0; }, 1500); track('cart_open', page.prod); setTimeout(function () { tagCart(false); }, 1500); }
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var el = m.target; if (!el.classList) return;
        var cls = el.className && typeof el.className === 'string' ? el.className : '';
        if (el === D.body) { if (/js-drawer-open-right/.test(cls)) cartNow(); else if (/js-drawer-open-left/.test(cls) && !el.__fdbMenu) { el.__fdbMenu = 1; setTimeout(function () { el.__fdbMenu = 0; }, 1500); track('menu_open', 'menu'); } return; }
        if (el.id === 'CartDrawer' && (el.classList.contains('drawer--is-open') || el.classList.contains('is-open'))) { cartNow(); return; }
        if (!el.classList.contains('is-open') && !el.classList.contains('drawer--is-open') && !el.classList.contains('mobile-nav--open')) return;
        if (el.__fdbOpen) return; el.__fdbOpen = 1; setTimeout(function () { el.__fdbOpen = 0; }, 1500);
        var id = el.id || el.getAttribute('data-drawer') || el.className.split(' ')[0];
        if (el.id === 'MobileNav' || el.classList.contains('mobile-nav--open')) track('menu_open', String(id).slice(0, 40)); else track('drawer_open', sectionOf(el) + '|' + String(id).slice(0, 40));
      });
    }).observe(D.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }
  // ---- forms: Shopify contact forms (help pop-up callback, contact page, newsletter) and classic product forms ----
  D.addEventListener('submit', function (e) {
    var f = e.target; if (!f || f.tagName !== 'FORM') return;
    var action = String(f.getAttribute('action') || '');
    if (/\/cart\/add/.test(action)) { track('atc_click', page.prod, priceShown(), { form: 1 }); return; }
    var inHelp = !!f.closest('[data-help-popup]');
    if (!inHelp && !/\/contact|\/customer|\/account/.test(action)) return;
    var id = f.id || f.getAttribute('name') || action.slice(0, 40), sec = sectionOf(f);
    var kind = inHelp ? 'callback' : /customer/.test(action) || /newsletter|subscribe/i.test(f.className + ' ' + id) ? 'newsletter' : (intent || 'contact');
    track('form_submit', id, 0, { kind: kind, section: sec });
    if (kind === 'callback') { track('callback_submit', id, 0, { section: sec }); store('s', 'fdb_cb_pending', '1'); }
  }, true);
  // Shopify reloads the page after a contact submit: the success banner on arrival confirms the request went through
  (function () {
    try {
      if (store('s', 'fdb_cb_pending') === '1') { store('s', 'fdb_cb_pending', ''); if (D.querySelector('.form-success, .note--success, .form-message--success, [data-help-success], .errors') ) track('callback_confirmed', location.hash.slice(1) || 'contact', D.querySelector('.errors') ? 0 : 1); }
    } catch (e) {}
  })();

  // ---- swipe rows: how far people get through a horizontal card row ----
  function carousels() {
    Array.prototype.forEach.call(D.querySelectorAll('[data-fdb-carousel]'), function (row) {
      var best = 0, t = null;
      row.addEventListener('scroll', function () {
        clearTimeout(t); t = setTimeout(function () {
          var kids = row.children, n = kids.length; if (n < 2 || row.scrollWidth <= row.clientWidth + 8) return;
          var mid = row.scrollLeft + row.clientWidth / 2, at = 0, bd = 1e9;
          for (var i = 0; i < n; i++) { var x = Math.abs(kids[i].offsetLeft - row.offsetLeft + kids[i].offsetWidth / 2 - mid); if (x < bd) { bd = x; at = i; } }
          if (row.scrollLeft + row.clientWidth >= row.scrollWidth - 8) at = n - 1;
          if (at > best) { best = at; track('carousel_step', sectionOf(row), at + 1, { total: n }); }
        }, 160);
      }, { passive: true });
    });
  }

  // any other sideways-scrolling block inside a section (comparison tables, card strips): how far it was swiped, 50% and to the end
  (function () {
    var hit = {}, t = null;
    D.addEventListener('scroll', function (e) {
      var el = e.target; if (!el || el === D || el.nodeType !== 1 || el.scrollWidth <= el.clientWidth + 24) return;
      if (el.matches('[data-fdb-carousel]') || el.closest('.builder-v2__gallery-thumbs, #CartDrawer, #MobileNav')) return;
      clearTimeout(t); t = setTimeout(function () {
        var sec = sectionOf(el); if (!sec) return;
        var pct = (el.scrollLeft + el.clientWidth) / el.scrollWidth, start = el.clientWidth / el.scrollWidth;
        [[50, start + (1 - start) * 0.5], [100, 0.97]].forEach(function (m) { var k = sec + '|' + m[0]; if (pct >= m[1] && el.scrollLeft > 8 && !hit[k]) { hit[k] = 1; track('swipe_row', sec, m[0]); } });
      }, 180);
    }, true);
  })();

  // ---- Builder 2.0: steps opened and completed by the shopper, sizes typed ----
  function builder() {
    var root = D.querySelector('[data-builder-steps]'); if (!root || !('MutationObserver' in W)) return;
    var opened = {}, done = {}, started = 0, interacted = 0;
    function keyOf(step, i) { var t = step.querySelector('.builder-v2__step-title'); var k = t ? (t.innerText || '').replace(/\s+/g, ' ').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 30) : ''; return k || ('step_' + (i + 1)); }
    function scan() {
      Array.prototype.forEach.call(root.querySelectorAll('.builder-v2__step'), function (s, i) {
        var k = keyOf(s, i), cl = s.classList;
        if (cl.contains('builder-v2__step--active') && !opened[k]) { opened[k] = 1; if (interacted) { if (!started) { started = 1; track('builder_start', page.prod, i + 1); } track('builder_step_open', k, i + 1); } }
        if (cl.contains('builder-v2__step--complete') && !done[k]) { done[k] = 1; if (interacted) { if (!started) { started = 1; track('builder_start', page.prod, i + 1); } var sel = s.querySelector('[data-step-selection]'); track('builder_step_done', k, i + 1, { selection: sel ? (sel.innerText || '').replace(/\s+/g, ' ').trim().slice(0, 60) : '' }); } }
      });
    }
    scan();   // whatever is open or pre-completed on load is not the shopper's doing
    D.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('[data-builder-steps]')) interacted = 1; }, true);
    D.addEventListener('keydown', function (e) { if (e.target && e.target.closest && e.target.closest('[data-builder-steps]')) interacted = 1; }, true);
    new MutationObserver(function () { scan(); }).observe(root, { attributes: true, subtree: true, attributeFilter: ['class'] });
    D.addEventListener('change', function (e) {
      var el = e.target; if (!el || !el.matches || !el.closest('[data-builder-steps]')) return;
      if (el.matches('.builder-v2__size-select, .bv2-width, .bv2-height, [name*="width" i], [name*="height" i]')) { var dim = /height/i.test(el.className + ' ' + (el.name || '') + ' ' + (el.id || '')) ? 'height' : 'width'; if (!/fraction/.test(el.className)) track('builder_size', dim, parseFloat(el.value) || 0); }
    }, true);
  }
  // ---- cart contents: what left the cart (cart_remove) or grew in it (cart_qty), from /cart.js snapshots ----
  // Clicks can't be trusted here: the cart page's remove handler stops them, bundles leave through /cart/update.js and plain remove
  // links navigate. So the last snapshot of the cart lives in localStorage (fdb_cart, shared by tabs) and is compared with /cart.js on
  // every page load and after every /cart/change|update|clear. A bundle (shared _Timestamp) counts as one thing, named and sized by its
  // parent line. A new cart token (an expired cart) resets silently, and so does a cart that is empty after Checkout was pressed (an order).
  var cartFetch = W.fetch;
  function cartGroups(cart) {
    var g = {};
    (cart.items || []).forEach(function (it) {
      var pr = it.properties || {}, ts = pr._Timestamp, k = ts ? 'b' + ts : 'l' + it.key;
      var c = g[k] || (g[k] = { q: 0, c: 0, n: '', k: ts ? 'shade' : /sample/i.test(it.product_type || '') ? 'sample' : /measuresafe/i.test(it.product_title || '') ? 'measuresafe' : 'item', s: '', u: 0 });
      c.c += it.final_line_price || 0;
      if (!ts || pr.Width || !c.n) {
        c.q = it.quantity;
        c.n = String((ts && pr.Bundle) || (pr['Protected Product'] ? 'MeasureSafe: ' + pr['Protected Product'] : it.product_title) || it.title || '').slice(0, 80);
        if (pr.Width) c.s = String(pr.Width) + ' x ' + String(pr.Height || '');
        if (pr._BundleSubtotal) c.u = Math.round(parseFloat(pr._BundleSubtotal) * 100) || 0;   // the per-shade price the cart page shows
      }
    });
    for (var k in g) { if (g[k].u) g[k].c = g[k].u * g[k].q; delete g[k].u; }
    return g;
  }
  function cartRead() { try { return JSON.parse(store('l', 'fdb_cart') || 'null'); } catch (e) { return null; } }
  function cartBrief() {   // runs inside the checkout click: must never throw, or the cart tag after it is skipped
    try { var s = cartRead(), out = []; if (s && s.g) for (var k in s.g) { var x = s.g[k] || {}; if (out.length < 12) out.push([String(x.n || '').slice(0, 50), x.s || '', x.q || 0, Math.round((x.c || 0) / 100)]); } return out; } catch (e) { return []; }
  }
  function cartSync(via) {   // via: page (load), ajax (a cart change this page made), add (refresh only; adds are add_to_cart)
    try {
      cartFetch.call(W, '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
        if (!cart) return;
        var prev = cartRead(), next = { t: cart.token || '', a: Date.now(), g: cartGroups(cart) }, n = 0;
        var ordered = !cart.item_count && prev && (parseInt(store('l', 'fdb_cart_co') || '0', 10) || 0) > (prev.a || 0);
        if (prev && prev.g && prev.t === next.t && via !== 'add' && !ordered) try {   // a bad old snapshot must not stop the new one being saved
          Object.keys(prev.g).forEach(function (k) {
            var a = prev.g[k], b = next.g[k], q = b ? b.q : 0, unit = a.q ? a.c / a.q : 0;
            if (q < a.q) { n++; track('cart_remove', a.n, Math.round(unit * (a.q - q) / 100), { kind: a.k, size: a.s, qty: a.q - q, left: q, via: via }); }
            else if (q > a.q && via === 'ajax') { n++; track('cart_qty', a.n, Math.round(unit * (q - a.q) / 100), { kind: a.k, size: a.s, qty: q - a.q, now: q, via: via }); }
          });
        } catch (e) {}
        store('l', 'fdb_cart', cart.item_count ? JSON.stringify(next) : '');
        if (n) send(false);   // removals usually come right before a reload: deliver them now
      }).catch(function () {});
    } catch (e) {}
  }
  // ---- every cart call the page makes: confirmed adds (Builder 2.0, sample buttons, the classic ajax cart) and changes ----
  function cartHook() {
    var RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    function done(kind, how) {
      if (kind === 'add') { track('add_to_cart', page.prod, priceShown(), { via: how }); setTimeout(function () { tagCart(false); }, 1500); }
      cartSync(kind === 'add' ? 'add' : 'ajax');
    }
    function attrsOnly(body) { return typeof body === 'string' && body.indexOf('"attributes"') > -1 && body.indexOf('"updates"') < 0; }   // tagCart's own write
    try {
      var of = W.fetch;
      if (of) W.fetch = function (input, init) {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        var p = of.apply(W, arguments), m = RE.exec(u);
        if (m && !attrsOnly(init && init.body)) p.then(function (r) { if (r && r.ok) done(m[1], 'fetch'); }).catch(function () {});
        return p;
      };
    } catch (e) {}
    try {
      var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) { try { this.__fdbCart = RE.exec(String(u)); } catch (e) {} return oo.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function (body) {
        try { var m = this.__fdbCart; if (m && !attrsOnly(body)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) done(m[1], 'xhr'); }); } catch (e) {}
        return os.apply(this, arguments);
      };
    } catch (e) {}
    D.addEventListener('cart:updated', function (e) { track('cart_updated', (e.detail && e.detail.source) || ''); });
  }

  function boot() { sectionViews(); gallery(); drawers(); carousels(); builder(); if (page.tpl === 'cart') { track('cart_open', page.prod, 0, { page: 1 }); tagCart(false); } if (page.tpl === 'cart' || cartRead()) cartSync('page'); }
  cartHook();
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
